import { createStore } from "vuex";
import { inits } from './storeInits.js'
// 删除 import menu from './modules/menu'

const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  if (value.default.init) {
    inits.push(value.default.init)
  }
  return modules
}, {})

// 无需额外操作，menu 模块会由 require.context 自动加载

const store = createStore({
  modules
})

export default store